/**
 * API endpoint constants.
 */
export const ControllerEndpoint = {
  BASE_PATH: '/api/v1',
  SessionControllerEndpoint: {
    SESSION: '/api/v1/auth/session',
    NEWSESSIONS: '/api/v1/auth/sessions/new',
    LOGOUT: '/api/v1/auth/session',
  },
  UserControllerEndpoint: {
    CREATEUSER: '/api/v1/auth/users/new',
    FORGOTPASSWORD: '/api/v1/auth/users/anonymous',
    PROFILE: '/api/v1/auth/user',
    EMAILOTP: '/api/v1/auth/user/{user-id}/anonymous',
  },
  OAuthControllerEndpoint: {
    LOGIN: '/api/v1/auth/oauth2/authorization/{registration-id}',
    CALLBACK: '/api/v1/auth/login/oauth2/code/{registration-id}',
  },
  OrchestratorControllerEndpoint: {
    NEWCHATWINDOW:
      '/api/v1/orchestrator/user-chat-windows/{chat-window-type}/new',
    NEWQUERIES: '/api/v1/orchestrator/user-queries/{chat-window-id}/new',
    CHATLIST: '/api/v1/orchestrator/user-chat-windows/{chat-window-type}',
    USERQUERYLIST: '/api/v1/orchestrator/user-chat-window/{chat-window-id}',
    EDITCHATWINDOW: '/api/v1/orchestrator/user-chat-window/{chat-window-id}',
    USERDATALIST:
      '/api/v1/orchestrator/user-query/{chat-window-id}/{user-query-id}/client-data/{page-number}',
  },
  DashboardControllerEndpoint: {
    NEWBOOKMARK: '/api/v1/dashboard/user-bookmarks/new',
    BOOKMARKLIST: '/api/v1/dashboard/user-bookmarks/{chat-window-type}',
  },
}
